import type { CalendarAttribute } from '../../schema/row-types.ts';
import type {
  RowOrderBy,
  RowQuery,
  SqliteQueryOptions,
} from '../../types/query.ts';
import { calendarAttributes } from '../../schema/tables/gtfs-plus/calendar-attributes.ts';
import { findRows } from '../sqlite-query.ts';

/**
 * Returns an array of all calendar_attributes that match the query parameters.
 * @param query Column values to match, as single values or arrays
 * @param fields Columns to select, or every column when empty
 * @param orderBy Column and direction pairs to sort by
 * @param options Query options, including the database to read from
 * @returns Matching rows, containing only `fields` when it is not empty
 */
export function getCalendarAttributes<Fields extends keyof CalendarAttribute>(
  query: RowQuery<CalendarAttribute> = {},
  fields: readonly Fields[] = [],
  orderBy: RowOrderBy<CalendarAttribute> = [],
  options: SqliteQueryOptions = {},
) {
  return findRows<CalendarAttribute, Fields>(
    calendarAttributes,
    query,
    fields,
    orderBy,
    options,
  );
}
